import api from "@modules/api/api";
import { useQuery } from "@tanstack/react-query";
import tradeInQueryKeys from "../types/tradeInQueryKeys";

type ResponseData = {
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  phone: string | null;
  streetAddress: string | null;
  provinceId: number | null;
  provinceAbbr: string | null;
  city: string | null;
  postalCode: string | null;
  latitude: number | null;
  longitude: number | null;
  year: number | null;
  make: string | null;
  model: string | null;
  originalDealerId: string | null;
  isAssociatedUser: boolean;
  isDealAlreadyCreated: boolean;
  isDealAlreadyAssociated: boolean;
  isAssociatedWithAuthenticatedUser: boolean;
  dealId: string | null;
  currentStepId: number | null;
  dropOffDetails: {
    dropOffLocationId: string | null;
    dropOffLocationAppointmentAt: string | null;
    dropOffLocationName: string | null;
  };
};

const performGet = async ({
  token,
  source,
}: {
  token: string;
  source: string;
}): Promise<ResponseData> => {
  return api.get(`api/trade-in/${source}/trade-in-for-token`, {
    headers: {
      authorization: `Bearer ${token}`,
    },
  });
};

export default function useTradeInFromToken({
  token,
  source,
  enabled = true,
}: {
  token: string | null;
  source: string | null;
  enabled?: boolean;
}) {
  const { data, isFetching } = useQuery({
    queryKey: tradeInQueryKeys.appraisalByToken(token as string),
    queryFn: () =>
      performGet({ token: token as string, source: source as string }),
    enabled: enabled && !!token && !!source,
  });

  return { tradeIn: data, isFetching };
}
